import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

function AdminStats(){

    const [numbUniquePlayers, setNumbUniquePlayers] = useState(0);
    const [numbGames, setNumbGames] = useState(0);
    const [numbImages, setNumbImages] = useState(0);
    const [numbQuizzes, setNumbQuizzes] = useState(0);

    const [accessToken, setAccessToken] = useState('emptyTokenInAdmin');
    const { getAccessTokenSilently } = useAuth0();


    useEffect(() => {

        const getAccessToken = async() => {
            try {
                const jwt = await getAccessTokenSilently();
                setAccessToken(jwt);
            } catch (error) {
                // token retrieval failed
            }
        }

        const fetchAdminStats = async () => {
            const adminStatsPromise = await fetch(process.env.REACT_APP_DATABASE_URL + '/admin', {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`
                }
            });
            const adminStatsResponse = await adminStatsPromise.json();

            if(adminStatsResponse.success === true) {
                setNumbUniquePlayers(adminStatsResponse.stats.numb_unique_players);
                setNumbGames(adminStatsResponse.stats.numb_games);
                setNumbImages(adminStatsResponse.stats.numb_images);
                setNumbQuizzes(adminStatsResponse.stats.numb_quizzes);
            } else if (adminStatsResponse.description){
                alert(`Issue accessing stats. Code: ${adminStatsResponse.code}. Description: ${adminStatsResponse.description}`);
            } else {
                alert(`Error: ${adminStatsResponse.error}. ${adminStatsResponse.status}`);
            };
        };

        getAccessToken();

        if( accessToken !== 'emptyTokenInAdmin') {
            fetchAdminStats();
        }

    }, [accessToken, getAccessTokenSilently]);

    return(
        <div className="max-w-7xl mx-auto px-4">
            <div className="md:w-1/3">
                <ul className="divide-y divide-gray-200 border border-gray-200 rounded">
                    <li className="px-4 py-2 text-sm">Number of unique users: {numbUniquePlayers}</li>
                    <li className="px-4 py-2 text-sm">Number of games played: {numbGames}</li>
                    <li className="px-4 py-2 text-sm">Number of quizzes: {numbQuizzes}</li>
                    <li className="px-4 py-2 text-sm">Number of images: {numbImages}</li>
                </ul>
            </div>
        </div>
    )
}

export default AdminStats;
